// extracted by mini-css-extract-plugin
export default {"btn":"btn-5WGImM","content":"content-ISvcar","title":"title-dMUSw1"};